@if (loading) {
  <mat-progress-bar mode="indeterminate" aria-label="Caricamento collezione in corso"></mat-progress-bar>
}

<header class="list-head">
  <h2 class="list-title">{{ title }}</h2>
  <p class="list-sub">
    {{ filteredList.length }} {{ filteredList.length === 1 ? 'gioco' : 'giochi' }}
    @if (searchTerm) { · risultati per <em>“{{ searchTerm }}”</em> }
  </p>
</header>

@if (isSustainLinkVisible()) {
  <p class="sustain-callout">
    <a [routerLink]="['/support']" class="custom-link">Scopri di più sulla campagna di sostegno a JustPlay →</a>
  </p>
}

<div class="list-controls">
  <div class="list-search">
    <label class="list-search-field">
      <span class="sr-only">Cerca un gioco</span>
      <svg class="list-search-icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="10.5" cy="10.5" r="6" fill="none" stroke="currentColor" stroke-width="1.8"/>
        <line x1="15" y1="15" x2="20" y2="20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
      <input
        type="search"
        placeholder="Cerca per titolo, complessità, durata…"
        autocomplete="off"
        [value]="searchTerm"
        (input)="onSearchInput($any($event.target).value)">
      @if (searchTerm) {
        <button type="button" class="list-search-clear" (click)="clearSearch()" aria-label="Cancella la ricerca">×</button>
      }
    </label>
  </div>

  <div class="view-toggle" role="group" aria-label="Come guardare la collezione">
    <button
      type="button"
      class="view-toggle-btn"
      [class.is-active]="view === 'shelf'"
      [attr.aria-pressed]="view === 'shelf'"
      (click)="setView('shelf')">
      <mat-icon svgIcon="bookshelf"></mat-icon>
      <span>Scaffale</span>
    </button>
    <button
      type="button"
      class="view-toggle-btn"
      [class.is-active]="view === 'table'"
      [attr.aria-pressed]="view === 'table'"
      (click)="setView('table')">
      <mat-icon svgIcon="view-list"></mat-icon>
      <span>Elenco</span>
    </button>
  </div>
</div>

@if (list.length && !filteredList.length) {
  <p class="list-empty">
    Nessun gioco trovato per <em>“{{ searchTerm }}”</em>.
    <button type="button" class="list-empty-clear" (click)="clearSearch()">Cancella ricerca</button>
  </p>
}

@if (filteredList.length && view === 'shelf') {
  <ul class="kallax">
    @for (game of filteredList; track game.bggId + game.title) {
      <li class="cubby">
        <a
          class="cubby-link"
          [attr.href]="game.bgg || null"
          [attr.target]="game.bgg ? '_blank' : null"
          [attr.rel]="game.bgg ? 'noopener' : null"
          [attr.aria-label]="game.bgg ? 'Apri la scheda BoardGameGeek di ' + game.title : null">
          <span class="cubby-shelf">
            @if (game.cover) {
              <img class="game-box" [src]="game.cover" alt="" loading="lazy" decoding="async">
            } @else {
              <span class="game-box game-box--blank">{{ game.title }}</span>
            }
          </span>
          <span class="cubby-title">{{ game.title }}</span>
        </a>
        <p class="cubby-meta">
          <span class="cubby-dot" [ngClass]="getComplexityDotClass(game)" aria-hidden="true"></span>
          <span class="sr-only">Complessità:</span>{{ game.complexity }}
          @if (game.players) { <span aria-hidden="true">·</span> <span class="sr-only">Giocatori:</span>{{ game.players }} }
          @if (game.duration) { <span aria-hidden="true">·</span> <span class="sr-only">Durata:</span>{{ game.duration }}′ }
        </p>
      </li>
    }
  </ul>
}

@if (filteredList.length && view === 'table') {
  <table mat-table [dataSource]="filteredList" matSort class="games-table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Titolo</th>
      <td mat-cell *matCellDef="let element">{{ element.title }}</td>
    </ng-container>

    <ng-container matColumnDef="players">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Giocatori</th>
      <td mat-cell *matCellDef="let element">{{ element.players }}</td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Durata</th>
      <td mat-cell *matCellDef="let element">{{ element.duration }}</td>
    </ng-container>

    <ng-container matColumnDef="complexity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Complessit&agrave;</th>
      <td mat-cell *matCellDef="let element">{{ element.complexity }}</td>
    </ng-container>

    <ng-container matColumnDef="bggurl">
      <th mat-header-cell *matHeaderCellDef>Dettagli</th>
      <td mat-cell *matCellDef="let element">
        @if (element.bgg) {
          <a [href]="element.bgg" target="_blank" rel="noopener" [attr.aria-label]="'Apri scheda BoardGameGeek di ' + element.title">BGG ↗</a>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row [ngClass]="getClassName(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
}
